var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.themeStyle)},[_c('div',[_c('v-row',{staticClass:"headline1_bg p-3",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v("\n          บทความ\n        ")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('all-blog')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a0bd40b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog/Blog.vue
// module id = null
// module chunks = 